import React from 'react';
import { useHistory } from 'react-router-dom';
import {
    usePropertyFetching,
    usePropertyPresentation,
} from '../../../../contextsProperty/ContextProperties';
import Title from '../../Title';
import Menu from '../../../components/Menu';
import Card from '../../../components/Card';
import Tag from '../../../../../muiComponents/Tag';
import {
    URL_PUBLIC_PORTRAIT,
    URL_TAB_PARAM,
} from '../../../../../utils/property/propertyUtils';
import colorVariables from '../../../../../stylesheets/variables.module.scss';
import LoadingPlaceholder from '../../../../../muiComponents/LoadingPlaceholder';
import LabelAndContentBlock from '../../LabelAndContentBlock';
import useUserProfile from '../../../../../customHooks/useUserProfile';

const PublicPortraitSection = () => {
    const history = useHistory();
    const path = history.location.pathname;

    const { readOnlyUser } = useUserProfile();
    const { description, services, hostSegments, mealPlanTypes } =
        usePropertyPresentation();
    const { isFetching } = usePropertyFetching();

    return (
        <section className='flex-column gap-5'>
            {isFetching ? (
                <LoadingPlaceholder variant='text' height={40} />
            ) : (
                <div className='flex flex-between flex-align-center'>
                    <Title text='description' />
                    {readOnlyUser ? (
                        ''
                    ) : (
                        <Menu
                            menuItems={[
                                {
                                    text: 'edit',
                                    icon: 'Edit',
                                    onClick: () => {
                                        history.push(
                                            `${path}${URL_PUBLIC_PORTRAIT}${URL_TAB_PARAM(
                                                1
                                            )}`
                                        );
                                    },
                                },
                                {
                                    type: 'divider',
                                },
                                {
                                    text: 'host_segment',
                                    icon: 'People',
                                    onClick: () => {
                                        history.push(
                                            `${path}${URL_PUBLIC_PORTRAIT}${URL_TAB_PARAM(
                                                3
                                            )}`
                                        );
                                    },
                                },
                                {
                                    text: 'services',
                                    icon: 'RoomService',
                                    onClick: () => {
                                        history.push(
                                            `${path}${URL_PUBLIC_PORTRAIT}${URL_TAB_PARAM(
                                                3
                                            )}`
                                        );
                                    },
                                },
                                {
                                    text: 'meal_plans_title',
                                    icon: 'Fastfood',
                                    onClick: () => {
                                        history.push(
                                            `${path}${URL_PUBLIC_PORTRAIT}${URL_TAB_PARAM(
                                                4
                                            )}`
                                        );
                                    },
                                },
                                {
                                    text: 'Descriptions',
                                    icon: 'Description',
                                    onClick: () => {
                                        history.push(
                                            `${path}${URL_PUBLIC_PORTRAIT}${URL_TAB_PARAM(
                                                5
                                            )}`
                                        );
                                    },
                                },
                                {
                                    text: 'notes',
                                    icon: 'StickyNote2',
                                    onClick: () => {
                                        history.push(
                                            `${path}${URL_PUBLIC_PORTRAIT}${URL_TAB_PARAM(
                                                6
                                            )}`
                                        );
                                    },
                                },
                                {
                                    text: 'Images',
                                    icon: 'Image',
                                    onClick: () => {
                                        history.push(
                                            `${path}${URL_PUBLIC_PORTRAIT}${URL_TAB_PARAM(
                                                7
                                            )}`
                                        );
                                    },
                                },
                            ]}
                        />
                    )}
                </div>
            )}

            <Card className='padding20 flex-column gap-20'>
                <div className='flex-column gap-5'>
                    <LabelAndContentBlock
                        label='description2'
                        content={description?.descriptionContent || '----'}
                        loading={isFetching}
                    />
                </div>

                <div className='flex-column gap-10'>
                    <LabelAndContentBlock
                        label='services'
                        content={
                            services.length ? (
                                <ul className='flex flex-wrap gap-10'>
                                    {services.map(service => (
                                        <li key={service.id}>
                                            <Tag
                                                text={service.name}
                                                variant='outlined'
                                                color={
                                                    colorVariables.accentColorCyan400
                                                }
                                            />
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                '----'
                            )
                        }
                        loading={isFetching}
                    />
                </div>
                <div className='flex-column gap-10'>
                    <LabelAndContentBlock
                        label='host_segment'
                        content={
                            hostSegments.length ? (
                                <ul className='flex flex-wrap gap-10'>
                                    {hostSegments.map(segment => (
                                        <li key={segment.id}>
                                            <Tag
                                                text={segment.name}
                                                variant='outlined'
                                                color={
                                                    colorVariables.accentColorOrange400
                                                }
                                            />
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                '----'
                            )
                        }
                        loading={isFetching}
                    />
                </div>
                <div className='flex-column gap-10'>
                    <LabelAndContentBlock
                        label='meal_plan'
                        content={
                            mealPlanTypes.length ? (
                                <ul className='flex flex-wrap gap-10'>
                                    {mealPlanTypes.map(meal => (
                                        <li key={meal.id}>
                                            <Tag
                                                text={meal.typeName}
                                                variant='outlined'
                                                color={
                                                    colorVariables.accentColorPurple400
                                                }
                                            />
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                '----'
                            )
                        }
                        loading={isFetching}
                    />
                </div>
            </Card>
        </section>
    );
};

export default PublicPortraitSection;
